import React, { useState } from 'react';
import { Table, Card, Row, Col, Avatar, Typography, Spin} from 'antd';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import TextEvents from 'app/components/TextEvents';
import CommunicationStatusContainer from 'app/containers/CommunicationStatusContainer';
import { useStyles, styles } from './CommunicationStatusScreenStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavMenu from 'components/NavMenu';

const { Title } = Typography;


export default function CommunicationStatusScreen(props) {

    const classes = useStyles();
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const value = props.location.search;
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} header='ERapids' isCommunicationStatus={true}/>
            <CssBaseline />
            <CommunicationStatusContainer idEmployee={value.slice(7)} classes={classes} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination}>
                        {(params) => {
                                return Object.keys(params.communicationProgram.employeeData).length > 1 ?
                                    <div className={`${classes.content}`}>
                                        <div className={classes.appBarSpacer} />
                                        <div elevation={0} style={styles.titleBox}>
                                            <Breadcrumbs aria-label="Breadcrumb">
                                                    Estatus de Comunicación
                                                <TextEvents
                                                    text={'Estatus de comunicación por persona'}
                                                    color="cotemar"
                                                    size='subtitle'
                                                    weight="bold"
                                                />
                                            </Breadcrumbs>
                                        </div>
                                        <div style={styles.baseVerticalMargin}>
                                            <Card className={classes.tabContainer}>
                                                <Row>
                                                    <Col span={8} offset={6}>
                                                        <Title level={3}> {params.communicationProgram.employeeData.EmployeeName}</Title>
                                                        {params.communicationProgram.employeeData.CategoryName}
                                                    </Col>
                                                    <Col span={4} offset={4}>
                                                        <Avatar size={100} src={params.communicationProgram.employeeData.UrlAvatar} icon="user" />
                                                    </Col>
                                                </Row>
                                            </Card>
                                            </div>
                                            <div style={styles.baseVerticalMargin}>
                                                <Card className={classes.tabContainer}>
                                                    <div>
                                                        <Table
                                                            loading={params.isLoading}
                                                            rowKey={item => String(item.idCommunication)}
                                                            columns={params.cols}
                                                            dataSource={params.communicationProgram.communicationStatus}
                                                            onChange={params.handleTableChange}
                                                            pagination={pagination}
                                                            scroll={{ x: 1800 }}
                                                            />
                                                    </div>
                                                </Card>
                                            </div>
                                    </div>
                                    :
                                    <div className={classes.example}>
                                        <Spin  tip="Cargando..."/>
                                    </div>
                        }}
                    </CommunicationStatusContainer>
        </div>
        )
}


